"use client";

import React from "react";
import AdminSidebar from "./AdminSidebar";
import AdminNavbar from "./AdminNavbar";
 
export default function AdminLayout({ children }) {
  return (
    <div className="d-flex">
      <AdminSidebar />

      <div className="flex-grow-1">
        <AdminNavbar />

        <main className="container-fluid py-4 bg-light min-vh-100">
          {children}
        </main>
      </div>
    </div>
  );
}